import { observer } from "mobx-react-lite";
import React from "react";
import { forwardRef } from "react";

const InternalTabsAnalytics = (
  { tabsDataProp, selectedTab, setSelectedTab },
  ref
) => {
  return (
    <div
      className="internal_tabs_main"
      style={{ width: 80 * tabsDataProp?.length }}
    >
      {" "}
      <div className="tabs int_tabs" ref={ref}>
        <ul
          style={{
            display: "flex",
            width: 80 * tabsDataProp?.length,
            justifyContent: "space-between",
          }}
        >
          {tabsDataProp.map((tabsData, index) => (
            <li
              style={{ marginRight: 0 }}
              key={index}
              className={
                selectedTab && selectedTab === tabsData?.name
                  ? "is-active"
                  : selectedTab === "" && index === 0
                  ? "is-active"
                  : ""
              }
              onClick={() => setSelectedTab(tabsData?.name, index)}
            >
              {/* <a></a> */}
              <button>{tabsData?.name}</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default observer(forwardRef(InternalTabsAnalytics));
